import { useState } from 'react'
import CellTabBar from './CellTabBar'
import { tabsByCell, newestTab } from './reviewComments'
import { type RequestComment } from './revisionRequest'

function Line({ c, withCell }: { c: RequestComment; withCell: boolean }) {
  return (
    <div>
      <span className="font-semibold">{c.author}</span>
      {withCell && c.cell_label ? <> on {c.cell_label}</> : null}: {c.body}
    </div>
  )
}

// Under a row of an editor page: the manager's revision request notes, then
// a sent-back review's comments with one tab per commented cell (opening on
// the newest). Overall Plan rows have one commentable number, so they list
// the review comments without tabs.
export default function RowNotes({ notes, withTabBar }: { notes: RequestComment[]; withTabBar: boolean }) {
  const requestNotes = notes.filter((c) => c.kind !== 'review')
  const tabs = tabsByCell(notes.filter((c) => c.kind === 'review'))
  const [picked, setPicked] = useState<string | null>(null)
  const active = tabs.find((t) => t.column_key === picked) ?? newestTab(tabs)
  return (
    <div className="flex flex-col gap-2 border-l-2 border-primary/40 bg-primary/5 px-4 py-2 text-[13px] text-foreground">
      {requestNotes.length > 0 && (
        <div>
          <div className="text-xs font-semibold">Revision request</div>
          {requestNotes.map((c) => <Line key={c.id} c={c} withCell={false} />)}
        </div>
      )}
      {active && (
        <div className="flex flex-col gap-1.5">
          <div className="text-xs font-semibold">Review comments</div>
          {withTabBar && (
            <CellTabBar
              tabs={tabs.map((t) => ({ key: t.column_key, label: t.label, count: t.comments.length }))}
              active={active.column_key}
              onSelect={setPicked}
            />
          )}
          <div>{active.comments.map((c) => <Line key={c.id} c={c} withCell={!withTabBar} />)}</div>
        </div>
      )}
    </div>
  )
}
